// The panel version the welcome intro («بوابة مشكاة») was last updated
// for. Bump it TOGETHER with a new entry at the top of RELEASES in
// introContent.js: every staff account then sees «ما الجديد» once, on
// its next visit. A deploy without release notes leaves it alone.
export const INTRO_VERSION = '2.18.0';

/** "2.1.0" vs "2.0.3" → 1 / 0 / -1, part by part as numbers. */
export function compareVersions(a, b) {
  const pa = String(a || '0').split('.').map(Number);
  const pb = String(b || '0').split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  return 0;
}
